import { z } from 'zod';
import { VisitorManagementProcessedEventSchema } from './external-event.visitor-management.types';

// export const externalEvent$ = z.discriminatedUnion('type', [
//   z.object({
//     type: z.literal('CHECKIN_CREATED')
//   }),
//   z.object({
//     type: z.literal('CHECKIN_UPDATED')
//   })
// ]);

export const externalEvent$ = z.discriminatedUnion('type', [
  z.object({ type: z.literal('CHECKIN_CREATED') }),
  z.object({ type: z.literal('CHECKIN_UPDATED') }),
  z.object({ type: z.literal('BOOKING_ARCHIVED') }),
  z.object({ type: z.literal('BOOKING_CANCELLED') }),
  z.object({ type: z.literal('BOOKING_UPDATED') }),
  z.object({ type: z.literal('PRODUCTION_ARCHIVED') }),
  z.object({ type: z.literal('PRODUCTION_CREATED') }),
  z.object({ type: z.literal('PRODUCTION_UPDATED') }),
  z.object({
    type: z.literal('VISITOR_MANAGEMENT_PROCESSED'),
    payload: VisitorManagementProcessedEventSchema
  })
]);
